import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cs-icon-live",
  "use": "cs-icon-live-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"cs-icon-live\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 128h-128v768h128zM448 320h128v576H448zM192 512h128v384H192z\" p-id=\"1420\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol